import { gql } from '@mineko/graphql-client';

export interface DecryptPartnerTokenResponse {
  DecryptPartnerToken: {
    isPremium: string;
    firstName: string;
    lastName: string;
    salutation: string;
    street: string;
    houseNumber: string;
    zipCode: string;
    city: string;
    email: string;
    phone: string;
  };
}

export default gql`
  query ($token: String!) {
    DecryptPartnerToken(token: $token) {
      isPremium
      firstName
      lastName
      salutation
      street
      houseNumber
      zipCode
      city
      email
      phone
    }
  }
`;
